<template lang="pug">
div
  //- small {{ sportsType }}
  //- Racing Sports
  template(v-if="racingList.includes(sportsType)")
    //- 45, 46, 49, 50, 51, 54
    template(v-if="racingList1.includes(sportsType)")
      //- 45, 46, 49
      template(v-for="(g1, g2) in group")
        efItem3(:source="g1" :index="parseInt(g2)" :key="g2")
    template(v-else)
      //- 50
      template(v-if="racingList2.includes(sportsType)" v-for="(g1, g2) in group")
        efItem5(:source="g1" :index="parseInt(g2)" :key="g2")
      //- 51
      template(v-if="racingList3.includes(sportsType)" v-for="(g1, g2) in group")
        efItem4(:source="g1" :index="parseInt(g2)" :key="g2")
      //- 54
      template(v-if="racingList4.includes(sportsType)" v-for="(g1, g2) in group")
        efItem6(:source="g1" :index="parseInt(g2)" :key="g2")
      //- 55
      template(v-if="racingList5.includes(sportsType)" v-for="(g1, g2) in group")
        efItem7(:source="g1" :index="parseInt(g2)" :key="g2")
      //- 56
      template(v-if="racingList6.includes(sportsType)" v-for="(g1, g2) in group")
        efItem8(:source="g1" :index="parseInt(g2)" :key="g2")
      //- 57
      template(v-if="racingList7.includes(sportsType)" v-for="(g1, g2) in group")
        efItem8(:source="g1" :index="parseInt(g2)" :key="g2")
  template(v-else)
    template(v-for="(g1, g2) in group")
      efItem2(:source="g1" :index="parseInt(g2)" :key="g2")
</template>

<script>
import config from '@/config';

export default {
  components: {
    efItem2: () => import("@/components/mobile/efight/efItem2.vue"),
    efItem3: () => import("@/components/mobile/efight/efItem3.vue"),
    efItem4: () => import("@/components/mobile/efight/efItem4.vue"),
    efItem5: () => import("@/components/mobile/efight/efItem5.vue"),
    efItem6: () => import("@/components/mobile/efight/efItem6.vue"),
    efItem7: () => import("@/components/mobile/efight/efItem7.vue"),
    efItem8: () => import("@/components/mobile/efight/efItem8.vue")
  },
  props: {
    source: {
      type: Array
    },
    sportsType: {
      type: Number
    }
  },
  data() {
    return {};
  },
  computed: {
    racingList() {
      return config.racingList;
    },
    racingList1() {
      return config.racingList1;
    },
    racingList2() {
      return config.racingList2;
    },
    racingList3() {
      return config.racingList3;
    },
    racingList4() {
      return config.racingList4;
    },
    racingList5() {
      return config.racingList5;
    },
    racingList6() {
      return config.racingList6;
    },
    racingList7() {
      return config.racingList7;
    },
    group() {
      var g = {};
      for (var i = 0; i < this.source.length; i++) {
        if (!g.hasOwnProperty(this.source[i].matchBody[9])) {
          g[this.source[i].matchBody[9]] = {
            items: [],
            teams: []
          };
        }

        g[this.source[i].matchBody[9]].items.push(this.source[i]);
        g[this.source[i].matchBody[9]].teams.push(this.source[i].homeTeam);
      }
      return g;
    }
  },
  mounted() {},
  methods: {}
}

</script>